import { Color } from './color.constants';

export const STATUS = {
  CRITICAL: 'error',
  WARNING: 'warning',
  UNKNOWN: 'unknown',
  IGNORED: 'ignored',
  OK: "ok",
  UNDEFINED: "undefined",
  TEST: "test",
  UNSUPPORTED: "unsupported",
} as const;

export const COLORS = {
  [STATUS.OK]: Color.health.ok,
  [STATUS.CRITICAL]: Color.health.critical,
  [STATUS.WARNING]: Color.health.warning,
  [STATUS.UNKNOWN]: Color.health.unknown,
  [STATUS.IGNORED]: Color.health.ignored,
  [STATUS.UNDEFINED]: Color.health.undefined,
  [STATUS.TEST]: Color.health.test,
  [STATUS.UNSUPPORTED]: Color.health.ignored,
} as const;

export const COLORS_DIM = {
  [STATUS.OK]: Color.health.dim.ok,
  [STATUS.CRITICAL]: Color.health.dim.critical,
  [STATUS.WARNING]: Color.health.dim.warning,
  [STATUS.UNKNOWN]: Color.health.dim.unknown,
  [STATUS.IGNORED]: Color.health.dim.ignored,
  [STATUS.UNDEFINED]: Color.health.dim.undefined,
  [STATUS.TEST]: Color.health.dim.test,
  [STATUS.UNSUPPORTED]: Color.health.dim.ignored,
}

export const HEALTH_STATUS_ITEM_ID = 'health-status';
export const HEATMAP_ITEM_ID = 'heatmap';